var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe01BulkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 8.44283 20.1427 5.31946 17.3449 3.54675C15.7989 2.56715 13.9657 2 12 2C6.85272 2 2.61375 5.88894 2.06103 10.8889C2.0207 11.2537 2 11.6244 2 12C2 15.1414 3.44852 17.9445 5.71407 19.7778C7.43155 21.1676 9.61856 22 12 22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 16.4443C17.4394 16.4443 16.4444 15.4494 16.4444 14.2221C16.4444 12.9948 15.4495 11.9999 14.2222 11.9999C12.9949 11.9999 12 11.005 12 9.77766C12 8.55036 12.9949 7.55544 14.2222 7.55544C15.4495 7.55544 16.4444 6.56052 16.4444 5.33322C16.4444 4.601 16.7986 3.95149 17.3449 3.54663C20.1427 5.31934 22 8.44271 22 11.9999C22 13.5964 21.6259 15.1055 20.9605 16.4443H18.6667Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22222 10.8888C5.44952 10.8888 6.44445 11.8837 6.44445 13.111C6.44445 14.3383 7.43937 15.3332 8.66667 15.3332C9.89397 15.3332 10.8889 16.3281 10.8889 17.5554C10.8889 18.7827 9.89397 19.7777 8.66667 19.7777L5.71407 19.7777C3.44852 17.9444 2 15.1413 2 11.9999C2 11.6243 2.0207 11.2536 2.06103 10.8888H4.22222Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe01BulkIcon);
export default __webpack_public_path__ + "static/media/globe01BulkIcon.e7c8a098274331b8c83412c8f48c9b1a.svg";
export { ForwardRef as ReactComponent };